@if (!customCurvesQuery.curves().length) {
  <div class="custom-curves-no-rows-overlay mb-4 mt-4 flex flex-col items-center justify-center">
    <div class="text-2xl font-bold">No Custom Curves Exist!</div>
    <div class="mt-1 text-lg">Create custom curves to use as custom forecast drivers.</div>
    <aux-button
      label="Curve"
      icon="Plus"
      class="create-curve__button mt-5"
      pendoTag="custom-curves-create-button"
      (click)="onCreateButtonClick()"
      [disabled]="!hasModifyCustomCurvePermission()"
      [auxTooltip]="noPermTooltip()"
    />
  </div>
} @else {
  <div class="custom-curves-no-rows-overlay flex items-center justify-center">No Rows To Show</div>
}
